import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardTitle } from '../components/ui/card';
import { Monitor, Smartphone, Droplets, Battery, HardDrive, Wrench, ArrowRight } from 'lucide-react';

interface RepairService {
  title: string;
  icon: React.ElementType;
  description: string;
}

const repairServices: RepairService[] = [
  { title: 'Board Repairs', icon: Monitor, description: 'Expert motherboard and logic board diagnostics.' },
  { title: 'Screen Repairs', icon: Smartphone, description: 'Cracked screen? We replace with genuine parts.' },
  { title: 'Water Damage', icon: Droplets, description: 'Fast recovery and ultrasonic cleaning.' },
  { title: 'Software Repair', icon: Monitor, description: 'OS issues, data recovery, and unlocking.' },
  { title: 'Battery Replacement', icon: Battery, description: 'Restore battery life with quality cells.' },
  { title: 'Data Recovery', icon: HardDrive, description: 'Retrieve lost data from damaged drives.' },
];

const BOOK_REPAIR_PATH = '/repairs/book';

export const RepairsPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="mb-12 text-center">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
          <Wrench className="h-7 w-7 text-primary" />
        </div>
        <h1 className="text-3xl font-bold md:text-4xl">Professional Device Repairs</h1>
        <p className="mx-auto mt-3 max-w-2xl text-[rgb(var(--light-secondary))]">
          Expert diagnosis and repair with genuine parts and a guaranteed service warranty.
          Book your repair online and track its progress from your dashboard.
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Link to={BOOK_REPAIR_PATH}>
            <Button variant="primary" size="lg">
              <Wrench className="mr-2 h-5 w-5" />
              Book a Repair
            </Button>
          </Link>
          <Link to="/dashboard/repairs">
            <Button variant="secondary" size="lg">
              Track My Repairs
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {repairServices.map((service) => {
          const Icon = service.icon;
          return (
            <Card key={service.title}>
              <CardTitle className="flex items-center gap-2">
                <Icon className="h-5 w-5 text-primary" />
                {service.title}
              </CardTitle>
              <p className="mt-2 text-sm text-[rgb(var(--light-secondary))]">{service.description}</p>
              <Link
                to={BOOK_REPAIR_PATH}
                className="mt-4 inline-block text-sm font-medium text-primary hover:underline"
              >
                Book this repair →
              </Link>
            </Card>
          );
        })}
      </div>
    </div>
  );
};